<template>
  <div>
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        分批发货基本信息
      </div>
      <div class="rj-page-card__content">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                分批申请单号：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.deliveryNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                合同编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.masterContractNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.masterProjectName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.createTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                分批发货金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.amountSum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.assignAll }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                未分配金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.unAssignAll? info.unAssignAll:0 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column fixed type="index" width="50" label="序号" align="left" />
        <el-table-column prop="telegraphicTransferNum" label="电汇底单编号" align="left" width="220" />
        <el-table-column prop="remittanceAmount" label="汇款金额" align="right" header-align="left" />
        <el-table-column prop="remittanceDate" label="汇款日期" align="left" />
        <el-table-column prop="importAccount" label="汇入账户" align="left" />
        <el-table-column prop="importCompany" label="汇入公司" align="left" />
        <el-table-column prop="summary" label="摘要" align="left" />
        <el-table-column prop="usedAmount" label="已使用金额" align="right" header-align="left" />
        <el-table-column prop="unusedAmount" label="可用余额" align="right" header-align="left" />
        <el-table-column prop="assignAmount" label="本次分配金额" align="left">
          <template v-slot="{row}">
            <el-input-number v-model="row.assignAmount" style="width:100%;" :precision="2" :min="0" label="描述文字" @blur="assignBlur(row)" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-button type="primary" style="margin-top:20px" @click="sureAAllocation">
      确认分配
    </el-button><span>
      本次分配金额：<span class="money">{{ assignAllTotal }} 元</span>
    </span>
    <sureAAllocation :dialog-form-visible="dialogFormVisible" :data="sureData" @on-status-dialog="updataDialogFormVisible" />
  </div>
</template>

<script>
import { selectAssignInfoByUserCodeAndContractNum, partialInvoiceDetail } from '@/API/index.js';
import { MathAdd } from '@/libs/util';
import sureAAllocation from './sureAAllocation';
export default {
  data () {
    return {
      info: {
        unAssignAll: 0
      },
      dialogFormVisible: false,
      loading: false,
      tableData: [],
      tableLoading: false,
      sureData: {
        dialogData: [],
        contractType: '',
        contractId: 0
      }
    };
  },
  components: {
    sureAAllocation
  },
  mounted () {
    this.initData();
  },
  computed: {
    assignAllTotal () {
      let total = 0;
      this.tableData.forEach((item) => {
        total = MathAdd(item.assignAmount ? item.assignAmount : 0, total);
      });
      return total;
    }
  },
  methods: {
    initData () {
      partialInvoiceDetail({ id: this.$route.query.id }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.info = json.data;
        } else {

        }
      }).catch((res) => {
      });
      selectAssignInfoByUserCodeAndContractNum(this.$route.query.masterContractNum).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          json.data.forEach((item) => {
            item.assignAmount = 0;
          });
          this.tableData = json.data;
        }
      }).catch((res) => {
      });
    },
    sureAAllocation () {
      this.sureData['contractNum'] = this.info.masterContractNum;
      this.sureData.dialogData = JSON.parse(JSON.stringify(this.tableData));
      this.sureData.dialogData.forEach((item) => {
        item.deliveryNum = this.info.deliveryNum;
        item.amountSum = this.info.amountSum;
      });
      // 过滤本次分配金额不为0 的
      let resData = this.sureData.dialogData.filter((item) => {
        return item.assignAmount > 0;
      });
      this.sureData.dialogData = resData;
      this.dialogFormVisible = true;
    },
    // 组件事件
    updataDialogFormVisible (val) {
      this.dialogFormVisible = val;
    },
    assignBlur (row) {
      if (row.unusedAmount < row.assignAmount) {
        row.assignAmount = row.unusedAmount;
      }
      let num = 0;
      this.tableData.forEach((item) => {
        if (item.assignAmount > 0) {
          num = num + item.assignAmount;
        }
      });
      if (num > this.info.unAssignAll) {
        this.$notify.warning('本次分配金额不能大于未分配金额，请进行调整');
        row.assignAmount = 0;
      }
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
